// src/app/helpers/cnpj.helper.ts

export function formatCnpj(value: string): string {
  const d = String(value || '').replace(/\D/g, '');

  // se não tiver 14 dígitos, retorna o original
  if (d.length !== 14) return value || '';

  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
}

